"use strict";
import React from "react";
import ResetPasswordLayout from "../../accounts_payable/reset_password/reset_password_layout";
import FormInput from "../../util/form_input";
import DisablingButton from "../../components/disabling_button";
import Auth from "../../util/auth";
import "../../components/flash_messages";
function newPasswordComplete() {
  window.location.replace("/app/login");
}
const ResetPasswordPage = React.createClass({
  //LIFECYCLE
  getInitialState: function() {
    return {
      sending: false,
      newPassword: null,
      passwordConfirmation: null,
      resetToken: window.location.search.slice(1).split("=")[1],
      resetPasswordError: null
    };
  },
  //STATE
  getNewPassword: function(e) {
    e.preventDefault();
    this.setState({ sending: true, resetPasswordError: null });
    Auth.resetPassword({
      reset_password_token: this.state.resetToken,
      password: this.state.newPassword,
      password_confirmation: this.state.passwordConfirmation
    }).then((user) => {
      newPasswordComplete();
    }).catch((error) => {
      const response = error.response;
      response.json().then((json) => {
        this.setState({ sending: false, resetPasswordError: json.errors });
      });
    });
  },
  newPasswordChanged: function(e) {
    this.setState({ newPassword: e.target.value });
  },
  passwordConfirmationChanged: function(e) {
    this.setState({ passwordConfirmation: e.target.value });
  },
  //RENDERING
  resetPasswordError: function() {
    let resetPasswordError;
    if (resetPasswordError = this.state.resetPasswordError) {
      const errorPairs = [];
      for (const key in resetPasswordError) {
        errorPairs.push(
          /* @__PURE__ */ React.createElement("div", { className: "alert-box alert radius" }, key, " ", resetPasswordError[key])
        );
      }
      if (errorPairs.length > 0) {
        return /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, errorPairs);
      } else {
        return /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement("div", { className: "alert-box alert radius" }, '"An unexpected error occurred, please try again."'));
      }
    }
  },
  passwordResetForm: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "small-6 small-centered column general-container-style" }, /* @__PURE__ */ React.createElement("h3", null, "Please Enter New Password"), /* @__PURE__ */ React.createElement("form", { onSubmit: this.getNewPassword, name: "resetPasswordForm" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, this.resetPasswordError(), /* @__PURE__ */ React.createElement(
      FormInput,
      {
        placeholder: "Password",
        onChange: this.newPasswordChanged,
        ref: "newPassword",
        value: this.state.newPassword,
        id: "password field",
        divClasses: "small-12 column",
        label: "New Password (8 characters minimum)",
        type: "password"
      }
    ), /* @__PURE__ */ React.createElement(
      FormInput,
      {
        placeholder: "Password",
        onChange: this.passwordConfirmationChanged,
        ref: "newPasswordConfirmation",
        value: this.state.passwordConfirmation,
        id: "password field",
        divClasses: "small-12 column",
        label: "New Password Confirmation",
        type: "password"
      }
    ), /* @__PURE__ */ React.createElement("div", { className: "small-12 column" }, /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabledText: "Resetting Password...",
        disabled: this.state.sending,
        className: "button--confirmation"
      },
      "Set New Password"
    )))));
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(ResetPasswordLayout, { "data-component": "ResetPasswordPage" }, this.passwordResetForm());
  }
});
export default ResetPasswordPage;
